import { useLayoutContext } from 'contexts/LayoutContext';
import React from 'react';
import { useParams } from 'react-router-dom';
import CreateReversalPage from './CreateReversalPage';
import CreateInvestmentReversalPage from './CreateInvestmentReversalPage';
import CreateRealisationReversalPage from './CreateRealisationReversalPage';
import ViewReversalPage from './ViewReversalPage';
import ViewGenericReversalPage from './ViewGenericReversalPage';
import ViewRealisationReversalPage from './ViewRealisationReversalPage';
import FormWrapper from './FormWrapper';
import ReversalFormWrapper from './ReversalFormWrapper';
import ViewInvestmentReversalPage from './ViewInvestmentReversalPage';

const ReversalPageWrapper: React.FC<{ mode: 'create' | 'view' }> = ({
  mode,
}) => {
  const { selectedVehicleId } = useLayoutContext();
  const { actionId, type } = useParams<{ actionId: string; type: string }>();

  if (!selectedVehicleId || !actionId) {
    return null;
  }

  if (type === 'investment' && mode === 'view') {
    return <ViewInvestmentReversalPage vehicleId={selectedVehicleId} />;
  }

  if (mode === 'view') {
    if (type === 'income-or-expense') {
      return <ViewReversalPage vehicleId={selectedVehicleId} />;
    }
    if (type === 'realisation') {
      return <ViewRealisationReversalPage vehicleId={selectedVehicleId} />;
    }
    return <ViewGenericReversalPage vehicleId={selectedVehicleId} />;
  }

  if (type === 'investment') {
    return (
      <ReversalFormWrapper actionId={actionId}>
        <CreateInvestmentReversalPage vehicleId={selectedVehicleId} />
      </ReversalFormWrapper>
    );
  }

  if (type === 'realisation') {
    return (
      <ReversalFormWrapper actionId={actionId}>
        <CreateRealisationReversalPage vehicleId={selectedVehicleId} />
      </ReversalFormWrapper>
    );
  }

  return (
    <FormWrapper groupId={actionId}>
      <CreateReversalPage vehicleId={selectedVehicleId} />
    </FormWrapper>
  );
};

export const CreateReversal: React.FC = () => (
  <ReversalPageWrapper mode="create" />
);
export const ViewReversal: React.FC = () => <ReversalPageWrapper mode="view" />;

export default ReversalPageWrapper;
